import {
  ModuleBackgroundColors,
  ModuleMargin,
  ModulePadding,
} from '../../shared/components/v2/ModuleSection/ModuleSection'
import { TEXT_FONT_COLOR, TEXT_FONT_STYLE, TEXT_TAG } from '../../shared/components/v2/Text/TextV2'
import { IBillboardWithImageProps } from '../../shared/components/v2/BillboardWithImage/BillboardWithImage'
import { MobileImageLocation, ModuleImagePositions } from '../../shared/components/v2/BillboardWithImage/BillboardImage'
import { ComponentType } from '../../shared/components/v2/types/componentType'
import { ITextBlockProps } from '../../shared/components/v2/TextBlock/TextBlock'
import { actionButtonStyle } from '../../shared/components/v2/ActionButton/ActionButton'

export const partnersBillboardWithWorkTogetherProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.XL, bottom: ModulePadding.XL },
  mobileModulePadding: { top: ModulePadding.XL, bottom: ModulePadding.NONE },
  dataTestId: 'envelopes-billboard-with-image',
  title: {
    tag: TEXT_TAG.h1,
    text: 'Let’s work together',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        'NorthOne is made for business builders. We’re on a mission to help our customers save time and money so they can focus on growing their business.',
      textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
    {
      tag: TEXT_TAG.p,
      text: 'If empowering American small business owners is what you’re all about, let’s work together.',
      textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    src: '/static/v2/partners-page/partnerships-lifestyle-1.png',
    mobileSrc: '/static/v2/partners-page/partnerships-lifestyle-1-mobile.png',
    alt: 'Phone, NorthOne Card and notification advising check cleared',
    position: ModuleImagePositions.centerBottom,
    mobileImageLocation: MobileImageLocation.BOTTOM,
    mobileFullWidth: true,
  },
}

export const partnersTextBlockWhatsInForYou: ITextBlockProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.goldTint1,
    mobile: ModuleBackgroundColors.goldTint1,
  },
  modulePadding: { top: ModulePadding.L, bottom: ModulePadding.SM },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.MD },
  title: {
    tag: TEXT_TAG.h2,
    text: `What’s in it for you?`,
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    sx: {
      marginBottom: '8px',
    },
  },
  dataTestId: 'open-account-text-block',
  body: [
    {
      type: ComponentType.StoryCardList,
      props: {
        storyCards: [
          {
            body: {
              tag: TEXT_TAG.p,
              text: 'Partner with America’s favorite digital bank for small business',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/partners-page/partnerships-puzzle-pieces.svg',
            imageAlt: 'Puzzle pieces icon',
            backgroundColor: { desktop: ModuleBackgroundColors.goldTint1 },
            sx: {
              alignItems: 'center',
              textAlign: 'center',
              height: 'auto',
              marginRight: '20px',
            },
          },
          {
            body: {
              tag: TEXT_TAG.p,
              text: 'Optimized landing pages to promote your company',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/partners-page/partnerships-optimized.svg',
            imageAlt: 'Smartphone icon',
            backgroundColor: { desktop: ModuleBackgroundColors.goldTint1 },
            sx: {
              alignItems: 'center',
              textAlign: 'center',
              height: 'auto',
              marginRight: '20px',
            },
          },
          {
            body: {
              tag: TEXT_TAG.p,
              text: 'Access to exclusive promotions and rewards',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/partners-page/partnerships-trophy.svg',
            imageAlt: 'Trophy icon',
            backgroundColor: { desktop: ModuleBackgroundColors.goldTint1 },
            sx: {
              alignItems: 'center',
              textAlign: 'center',
              height: 'auto',
            },
          },
        ],
      },
    },
  ],
}

export const partnersBillboardWithBecomeAffiliateProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.NONE },
  mobileModulePadding: { top: ModulePadding.NONE, bottom: ModulePadding.XS },
  moduleMargin: { top: ModuleMargin.L, bottom: ModuleMargin.XL },
  mobileModuleMargin: { bottom: ModuleMargin.MD },
  copyLocation: 'right',
  dataTestId: 'envelopes-billboard-with-image',
  title: {
    tag: TEXT_TAG.h2,
    text: 'Become a NorthOne affiliate',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    sx: {
      marginTop: ['32px', '32px', 'auto'],
    },
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        'If you’re a blogger, content marketer, web publication, or consultant focused on helping small businesses, we want to hear from you.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
    {
      tag: TEXT_TAG.p,
      text:
        'This is your chance to introduce your audience to America’s fastest-growing business banking app. For every referral that opens a NorthOne account, you’ll make a commission.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
      sx: {
        paddingBottom: ['16px', '16px', 'auto'],
      },
    },
  ],
  billboardImage: {
    src: '/static/v2/partners-page/partnerships-lifestyle-2.png',
    mobileSrc: '/static/v2/partners-page/partnerships-lifestyle-2-mobile.png',
    alt: 'Phone showing NorthOne app home screen',
    position: ModuleImagePositions.centerBottom,
    mobileImageLocation: MobileImageLocation.TOP,
    mobileFullWidth: true,
    sx: {
      margin: ['auto', 'auto', 'auto', '-104px auto auto 0'],
      marginTop: ['-64px', '-64px', '-64px', '-104px'],
      marginLeft: ['-32px', '-32px', '-32px', '0'],
      width: ['300px', '300px', 'auto', 'auto'],
      alignSelf: 'start',
    },
  },
  actionButton: {
    body: {
      tag: TEXT_TAG.p,
      text: 'Apply for an Account',
      textFontStyle: TEXT_FONT_STYLE.ctaButton,
      textFontColor: TEXT_FONT_COLOR.white,
    },
    link: 'https://join.northone.com/',
    buttonStyle: actionButtonStyle.blackPrimary,
    sx: {
      marginBottom: '32px',
    },
  },
  sx: {
    maxHeight: ['none', 'none', 'none', '510px'],
    paddingLeft: ['32px', '32px', '32px', '0'],
    paddingRight: ['32px', '32px', '32px', '0'],
    backgroundColor: ModuleBackgroundColors.goldTint2,
    'div > div': {
      maxWidth: '400px',
    },
  },
}

export const partnersBillboardWithBecomePartnerProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.NONE, bottom: ModulePadding.XS },
  mobileModulePadding: { top: ModulePadding.NONE, bottom: ModulePadding.MD },
  dataTestId: 'envelopes-billboard-with-image',
  title: {
    tag: TEXT_TAG.h2,
    text: 'Become a NorthOne partner ',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        'We’re on the lookout for opportunities to work with innovative companies that share our passion for helping small businesses.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
    {
      tag: TEXT_TAG.p,
      text: 'If that sounds like you, let’s chat!',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
    {
      tag: TEXT_TAG.p,
      text:
        'Tell us about your business and why you think we’d make a good match by sending an email to <a href="mailto:partnerships@northone.com">partnerships@northone.com</a>',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
      sx: {
        marginBottom: ['32px !important', '32px !important', 'auto'],
      },
    },
  ],
  billboardImage: {
    src: '/static/v2/partners-page/partnerships-lifestyle-3.png',
    mobileSrc: '/static/v2/partners-page/partnerships-lifestyle-3-mobile.png',
    alt: 'Phone showing NorthOne app home screen',
    position: ModuleImagePositions.centerBottom,
    mobileImageLocation: MobileImageLocation.TOP,
    mobileFullWidth: true,
    sx: {
      marginTop: ['-48px', '-48px', '-48px', '0'],
      marginRight: ['-32px', '-32px', '-32px', '0'],
      width: ['100%', '100%', 'auto'],
      alignSelf: 'end',
    },
  },
  sx: {
    backgroundColor: ModuleBackgroundColors.goldTint4,
    paddingLeft: ['32px', '32px', '32px', '74px'],
    paddingRight: ['32px', '32px', '32px', '0'],
  },
}
